import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { FaBuilding, FaClipboardList, FaSave } from 'react-icons/fa';
import DefaultButton from './DefaultButton';
import './ConfigurationFormLayout.css';

export function ConfigurationSection({ title, description }) {
    return <div className="configuration-section"><h5>{title}</h5><p>{description}</p></div>;
}

export default function ConfigurationFormLayout({ title, description, kind, children, summary, formId, backTo, saveLabel, loading, disabled }) {
    const Icon = kind === 'faculty' ? FaBuilding : FaClipboardList;
    return <div className={`configuration-page configuration-page--${kind}`}>
        <header className="card configuration-page-header hidethis"><div className="card-body">
            <div className="configuration-page-heading"><span className="configuration-page-icon"><Icon /></span><div><h4>{title}</h4><p>{description}</p></div></div>

        </div></header>
        <div className={`configuration-workspace${summary ? ' has-summary' : ''}`}>
            <section className="card configuration-fields"><div className="card-body">{children}
            <div className="configuration-page-actions configuration-page-footer hidethis"><DefaultButton text="Voltar" bg="secondary" to={backTo} />
                <Button variant="success" type="submit" form={formId} disabled={disabled || loading}>
                    {loading ? <Spinner animation="border" size="sm" /> : <FaSave />} {loading ? 'Salvando…' : saveLabel}
                </Button>
            </div>
            </div></section>
            {summary && <aside className="configuration-summary-column hidethis" aria-label="Resumo das configurações">{summary}</aside>}
        </div>
    </div>;
}
